import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { BaseStoreService } from 'src/app/service/base-store/base-store.service';

declare global {
  interface Window {
    Tawk_API?: any;
  }
}

@Component({
  selector: 'app-tawk-live-chat',
  template: '',
})
export class TawkLiveChatComponent implements OnInit, OnDestroy {
  liveChatEnabled = false;
  liveChatId: any;
  subscription: Subscription;
  constructor(private baseStoreService: BaseStoreService) {}

  ngOnInit() {
    this.subscription = this.baseStoreService.getLiveChatData().subscribe((liveChatdata: any) => {
      if (liveChatdata.liveChatEnabled) {
        this.liveChatEnabled = liveChatdata.liveChatEnabled;
        this.liveChatId = liveChatdata.liveChatId || '5eaa1b7310362a7578bd9e00/default';
        if (this.liveChatEnabled && this.liveChatId) {
          const s1 = document.createElement('script');
          const s0 = document.getElementsByTagName('script')[0];
          s1.async = true;
          s1.src = `https://embed.tawk.to/${this.liveChatId}`;
          // tslint:disable-next-line: deprecation
          s1.charset = 'UTF-8';
          s1.setAttribute('crossorigin', '*');
          s0.parentNode.insertBefore(s1, s0);
          if (window.Tawk_API) {
            window.location.reload(); // needs to reload to change to another chat widget
            window.Tawk_API.showWidget();
          }
        }
      } else {
        if (window.Tawk_API) {
          window.Tawk_API.hideWidget();
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
